
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1138_24125)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5C3 2.32843 2.32843 3 1.5 3ZM37 4.5C37 5.32843 37.6716 6 38.5 6C39.3284 6 40 5.32843 40 4.5C40 3.67157 39.3284 3 38.5 3C37.6716 3 37 3.67157 37 4.5ZM1 38.5C1 39.3284 1.67157 40 2.5 40C3.32843 40 4 39.3284 4 38.5C4 37.6716 3.32843 37 2.5 37C1.67157 37 1 37.6716 1 38.5Z","fill":"#16171F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.73 20C36.73 29.2397 29.2397 36.73 20 36.73C10.7603 36.73 3.27 29.2397 3.27 20C3.27 10.7603 10.7603 3.27 20 3.27C29.2397 3.27 36.73 10.7603 36.73 20ZM40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM20 8.85278C21.0954 8.85278 21.9834 9.74081 21.9834 10.8363V10.9949C21.9834 12.0904 21.0954 12.9784 20 12.9784C18.9045 12.9784 18.0165 12.0904 18.0165 10.9949V10.8363C18.0165 9.74081 18.9045 8.85278 20 8.85278ZM20 32.2312C19.0962 32.2312 18.3636 31.4172 18.3636 30.413V18.4199C18.3636 17.4157 19.0962 16.6017 20 16.6017C20.9037 16.6017 21.6363 17.4157 21.6363 18.4199L21.6363 30.413C21.6363 31.4172 20.9037 32.2312 20 32.2312Z","fill":"#5D5CFD"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1138_24125"}},[_c('rect',{attrs:{"width":"40","height":"40","fill":"white"}})])])])
          )
        }
      }
    